module.exports = __webpack_public_path__ + "6add0f93c1d78d4230b3b9942c0bd6de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic15.png
// module id = 1859
// module chunks = 0